






















































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */

import { BaseModel } from "@/models/products/base";
import { ChairModel } from "@/models/products/chair";
import { UmbrellaModel } from "@/models/products/umbrella";
import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class SpecsModal extends Vue {
  @Prop() data!: UmbrellaModel | BaseModel | ChairModel[];

  protected close(): void {
    this.$emit("close");
  }
}
